export const SECTION_LINE_WIDTH = 8; // px
